import React from 'react';
import Icon from '../../../components/AppIcon';

const ActivityFeed = ({ activities }) => {
  const getActivityIcon = (type) => {
    switch (type) {
      case 'application':
        return { name: 'FileText', color: 'var(--color-primary)' };
      case 'shortlist':
        return { name: 'Star', color: 'var(--color-warning)' };
      case 'interview':
        return { name: 'Calendar', color: 'var(--color-success)' };
      case 'message':
        return { name: 'MessageSquare', color: 'var(--color-accent)' };
      default:
        return { name: 'Bell', color: 'var(--color-muted-foreground)' };
    }
  };

  const formatTimeAgo = (timestamp) => {
    const now = new Date();
    const activityTime = new Date(timestamp);
    const diffMs = now - activityTime;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMins < 60) return `${diffMins} minutes ago`;
    if (diffHours < 24) return `${diffHours} hours ago`;
    return `${diffDays} days ago`;
  };

  return (
    <div className="space-y-4">
      {activities?.map((activity) => {
        const iconConfig = getActivityIcon(activity?.type);
        return (
          <div key={activity?.id} className="flex gap-3 p-4 bg-muted/50 rounded-lg transition-smooth hover:bg-muted">
            <div className="flex-shrink-0">
              <div className="w-10 h-10 rounded-full bg-card border border-border flex items-center justify-center">
                <Icon name={iconConfig?.name} size={18} color={iconConfig?.color} />
              </div>
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm text-foreground mb-1">{activity?.message}</p>
              <p className="text-xs text-muted-foreground">{formatTimeAgo(activity?.timestamp)}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ActivityFeed;